import { action, observable, makeObservable } from "mobx";

import { PartnerCustomerInventoryTag } from "../models/inventory/PartnerCustomerInventoryTag";
import PartnerCustomerInventoryTagsAPI from "../api/PartnerCustomerInventoryTagsAPI";

export class PartnerCustomerInventoryTagsStore {
  partnerCustomerInventoryTags: PartnerCustomerInventoryTag[] = [];
  partnerCustomerInventoryTagsAPI: PartnerCustomerInventoryTagsAPI;

  constructor() {
    this.partnerCustomerInventoryTags = [];
    this.partnerCustomerInventoryTagsAPI =
      new PartnerCustomerInventoryTagsAPI();

    makeObservable(this, {
      partnerCustomerInventoryTags: observable,
      getPartnerCustomerInventoryTagsByCustomerId: action,
    });
  }

  getPartnerCustomerInventoryTagsByCustomerId = async (customerId: number) => {
    try {
      const response =
        await this.partnerCustomerInventoryTagsAPI.getTagsByCustomerId(
          customerId,
        );
      this.partnerCustomerInventoryTags = response;
    } catch (error) {
      throw error;
    }
  };
}
